import { Text } from 'components';
import { CheckmarkCircleIcon, CrossCircleIcon, InfoCircleIcon } from 'components/Icon';

import styles from './PricingStatusCard.module.scss';

export type PricingStatusCardProps = {
  type: 'success' | 'warn' | 'error';
  title?: string;
  text?: string;
};

const PricingStatusCard = ({ type, title, text }: PricingStatusCardProps) => {
  const renderIcon = () => {
    switch (type) {
      case 'success':
        return <CheckmarkCircleIcon fill="green" />;
      case 'warn':
        return <InfoCircleIcon fill="orange" />;
      case 'error':
        return <CrossCircleIcon fill="red" />;

      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      <div className="text-center mb-12">{renderIcon()}</div>

      <div className="mb-16 text-center">
        <Text size="h2" weight="bold">
          {title}
        </Text>
      </div>
    </div>
  );
};

export default PricingStatusCard;
